export const instructionConstraints = {
  filePath: {
    maxLength: 1000,
  },
  list: {
    limit: {min: 1, max: 100, default: 100},
    offset: {min: 0, default: 0},
    query: {max: 1000},
  },
  content: {
    maxLength: 256 * 1024,
  },
  importArchive: {
    maxBytes: 10 * 1024 * 1024,
    maxFiles: 250,
    maxUncompressedBytes: 20 * 1024 * 1024,
  },
} as const;

export const systemInstructionConstraints = {
  rootFolderName: 'wf',
  pathPrefix: 'wf/',
} as const;

export const agentSkillConstraints = {
  fileName: 'SKILL.md',
  name: {
    maxLength: 64,
  },
} as const;

/**
 * Request header carrying the Designer tab that wrote an instruction, so the
 * realtime change signal can skip that tab. A header rather than a body field:
 * the write body schema is strict, and an unknown field would fail the save.
 */
export const DESIGNER_SESSION_ID_HEADER = 'x-wf-designer-session-id';

export const agentRuleConstraints = {
  rootFolderName: 'rules',
  pathPrefix: 'rules/',
} as const;

export const LIBRARY_INSTRUCTIONS_ROOT_FOLDER = 'wf_libraries';
